import React, { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  MenuItem,
  Typography,
  Divider,
  Tooltip
} from "@mui/material";

/* ===== COLORS (MATCH YOUR APP) ===== */
const COLORS = {
  pageBg: "#FFFFFF",
  cardBg: "#FFFFFF",
  accent: "#F5C400",
  accentHover: "#E0B200",
  title: "#1A1A1A",
  textSecondary: "#6B7280",
  border: "#E5E5E5",
};

/* ===== SIMPLE EMAIL REGEX ===== */
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const AddUser = () => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  const [emailError, setEmailError] = useState("");
  const [roleError, setRoleError] = useState("");

  /* ===== VALIDATION ===== */
  const validateEmail = (value) => {
    if (!value) return "Email is required";
    if (!emailRegex.test(value)) return "Enter a valid email address";
    return "";
  };

  const validateRole = (value) => {
    if (!value) return "Role is required";
    return "";
  };

  const handleSubmit = async () => {
  const emailErr = validateEmail(email);
  const roleErr = validateRole(role);

  setEmailError(emailErr);
  setRoleError(roleErr);

  if (emailErr || roleErr) return;

  const generatePasswordFromEmail = (email) => {
  const usernamePart = email.split("@")[0];
  return `${usernamePart}@123`;
};
const password = generatePasswordFromEmail(email);

  const payload = {
    username: email,          // backend requires username
    email: email,
    password: password,   // required by backend
    role: [role.toLowerCase()] // admin | sales | user
  };

  try {
    const user = JSON.parse(sessionStorage.getItem("user"));
const url =  `${process.env.REACT_APP_SERVER_URL}/savyandsons/auth/signup`;
    const response = await fetch(
     url,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        //   Authorization: `Bearer ${user.accessToken}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      // Backend validation message
         swal("Error", "Failed to add user");
      return;
    }

    // ✅ SUCCESS

    swal("Success", "User added successfully", "success");

    setEmail("");
    setRole("");
  } catch (error) {
    console.error("Add user error:", error);
    alert("Something went wrong. Please try again.");
  }
};


  const isFormValid =
    email &&
    role &&
    !validateEmail(email) &&
    !validateRole(role);

     const tooltipText = !isFormValid
    ? "Enter a valid email and select a role to enable"
    : "Click to add the user";

  return (
    <Box
      sx={{
        backgroundColor: COLORS.pageBg,
        minHeight: "100vh",
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 2, md: 4 },
      }}
    >
      {/* PAGE TITLE */}
      <Typography
        sx={{
          fontSize: { xs: 20, sm: 22, md: 24 },
          fontWeight: 700,
          color: COLORS.title,
          mb: 0.5,
        }}
      >
        User Management
      </Typography>

      {/* DESCRIPTION */}
      <Typography
        sx={{
          fontSize: { xs: 12, sm: 13 },
          color: COLORS.textSecondary,
          mb: 3,
          maxWidth: 640,
        }}
      >
        Add a user and assign a role.
      </Typography>

      {/* FORM WRAPPER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" },
        }}
      >
        <Paper
          elevation={2}
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", sm: 480, md: 520 },
            p: { xs: 2, sm: 3 },
            borderRadius: 2,
            border: `1px solid ${COLORS.border}`,
          }}
        >
          {/* CARD TITLE */}
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 18 },
              fontWeight: 600,
              color: COLORS.title,
              mb: 2,
            }}
          >
            Add User
          </Typography>

          <Divider sx={{ mb: 3 }} />

          {/* EMAIL */}
          <TextField
            label="Email"
            type="email"
            placeholder="user@example.com"
            fullWidth
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError("");
            }}
            onBlur={() => setEmailError(validateEmail(email))}
            error={Boolean(emailError)}
            helperText={emailError}
            sx={{ mb: 3 }}
          />

          {/* ROLE */}
          <TextField
            label="Role"
            select
            fullWidth
            value={role}
            onChange={(e) => {
              setRole(e.target.value);
              setRoleError("");
            }}
            onBlur={() => setRoleError(validateRole(role))}
            error={Boolean(roleError)}
            helperText={roleError}
            sx={{ mb: 4 }}
          >
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="sales">Sales</MenuItem>
          </TextField>

          {/* ACTION WITH TOOLTIP */}
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "stretch", sm: "flex-start" },
            }}
          >
            <Tooltip title={tooltipText} arrow placement="bottom">
              <span style={{ width: "100%" }}>
                <Button
                  disabled={!isFormValid}
                  onClick={handleSubmit}
                  fullWidth
                  sx={{
                    backgroundColor: "#F3C26B",
                    color: COLORS.title,
                    fontWeight: 700,
                    height: 44,
                    borderRadius: 1.5,
                    maxWidth: { sm: 200 },
                    opacity: isFormValid ? 1 : 0.6,
                    "&:hover": {
                      backgroundColor: "#F3C26B",
                    },
                    "&.Mui-disabled": {
                      color: COLORS.title,
                    },
                  }}
                >
                  Add User
                </Button>
              </span>
            </Tooltip>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default AddUser;
